import './App.css';
import { createBrowserRouter, RouterProvider } from "react-router"
import Header from './components/Header';
import Login from './components/Login';
import LandingPage from './components/LandingPage';
import Dashboard from './components/Dashboard';
// import User from './components/User';
import Students from './components/Students';
import ManageContent from './components/ManageContent';
import Masters from './components/Masters';
import Users from './components/Users';
import PrivateRoute from './components/PrivateRoute';

const router = createBrowserRouter([
  {
    path: "/",
    element: <LandingPage />
  },
  {
    path: "/login",
    element: <Login />
  },

  {
    element: <PrivateRoute />,
    children: [
  // {
  //   path: "/dashboard",
  //   element: <Dashboard />

  // },
  {
    path: "/students",
    element: <Students />
  },
  {
    path: "/manage-content",
    element: <ManageContent />
  },
  {
    path: "/masters",
    element: <Masters />
  },
  {
    path: "/users",
    element: <Users />
  }
    ]
  }

])

function App() {
  return <RouterProvider router={router} />
}

export default App;
